import useThread from '../../hooks/useThread';
import styles from './suggestions.module.scss';
import useSession from '@/hooks/useSession';
const Suggestions = () => {
  const { session, orgIndex, pushUserEvent } = useSession();
  const { organizations } = session;
  const { handlePromptSubmit } = useThread();

  const handleSuggestionClick = (suggestion: string) => {
    pushUserEvent('click_suggestion');
    handlePromptSubmit(suggestion);
  };

  return (
    <ul className={styles['suggestions']}>
      {organizations[orgIndex].suggestions.map(
        (suggestion: string, i: number) => (
          <li
            data-testid="suggestion"
            key={i}
            className={styles['suggestion']}
            onClick={() => handleSuggestionClick(suggestion)}
          >
            {suggestion}
          </li>
        )
      )}
    </ul>
  );
};

export default Suggestions;
